export default "__VITE_ASSET__DsBSs4Sy__"